export const CustomDate = (convertedDate) => {
    let date;
    let month;
    let year;
    let newDate;
    let dmyDate;
    // convertedDate ? typeof (convertedDate) === "string" ? convertedDate : dmyDate : ""
    const createdDate = convertedDate && new Date(convertedDate);
    if (typeof (convertedDate) === "string") {
        let myDate = convertedDate.split("/");
        let newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
        let dt = new Date(newDate);
        date = dt && dt?.getDate()
        month = dt && dt?.getMonth() + 1
        year = dt && dt?.getFullYear()
        newDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        newDate = newDate === "NaN/0NaN/0NaN" ? "-" : newDate;
        dmyDate = (date > 9 ? date : "0" + date) + "/" + (month > 9 ? month : "0" + month) + "/" + year
        dmyDate = dmyDate === "NaN/0NaN/0NaN" ? "-" : dmyDate;
        // dmyDate = convertedDate
    } else {
        const temp = new Date(convertedDate)
        date = temp && temp?.getDate()
        month = temp && temp?.getMonth() + 1
        year = temp && temp?.getFullYear()
        newDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        newDate = newDate === "Invalid date" ? "-" : newDate;
        dmyDate = (date > 9 ? date : "0" + date) + "/" + (month > 9 ? month : "0" + month) + "/" + year
        dmyDate = dmyDate === "Invalid date" ? "-" : dmyDate;
    }
    return { newDate, dmyDate }

}
export const CustomAPIDate = (convertedDate) => {
    const toDate = (value) => {
        if (!value) return null;
        if (value?._d) return value._d;
        if (value instanceof Date) return value;
        if (typeof value === "string") {
            const parts = value.split("/");
            if (parts.length === 3) {
                const [first, second, third] = parts.map(Number);
                if (parts[0].length === 4) return new Date(first, second - 1, third);
                return new Date(third, second - 1, first);
            }
        }
        return new Date(value);
    };

    const createdDate = toDate(convertedDate);
    const isValidDate = createdDate instanceof Date && !Number.isNaN(createdDate.getTime());
    if (!isValidDate) {
        return { newDate: "-", dmyDate: "-", month: "-", date: "-" };
    }

    const date = createdDate.getDate();
    const month = createdDate.getMonth() + 1;
    const year = createdDate.getFullYear();
    const paddedDate = date > 9 ? `${date}` : `0${date}`;
    const paddedMonth = month > 9 ? `${month}` : `0${month}`;
    const newDate = `${year}/${paddedMonth}/${paddedDate}`;
    const dmyDate = `${paddedDate}/${paddedMonth}/${year}`;

    return { newDate, dmyDate, month: paddedMonth, date: paddedDate }
}
export const StringToDate = (strDate) => {
    var myDate = strDate.split("/");
    var newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
    let dt = new Date(newDate);
    dt = dt === "Invalid date" ? "-" : dt;
    return { dt };
}

export const dashedDate = (date) => {
    let newDate = null;
    if (date) {
        const dateValue = date.split("/");
        newDate = dateValue?.[2] + "-" + dateValue?.[1] + "-" + dateValue?.[0];
    }
    return { newDate };
}
